import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { slide as Menu } from 'react-burger-menu';
import {Nav} from "react-bootstrap";

var tot = 0
var taxrate = 0.0915
class Sidebar extends Component{
    constructor(props) {
        super(props);
    }   
    render(){
        var totalWithTax=0
        tot = parseFloat(this.props.total)
        var totTax = parseFloat((tot * taxrate)).toFixed(2)
        totalWithTax = (parseFloat(tot) + parseFloat(totTax)).toFixed(2);
     return(
           <ul className="right">
                       
                       <li><Link style ={{color:"black"}} to="/cart">${totalWithTax}</Link></li>
                       <li><Link style ={{color:"black"}} to="/cart"><i className="material-icons">shopping_cart</i></Link></li>
                   </ul>

         

     )
    }
}

const mapStateToProps = (state)=>{
    return{
        addedItems: state.addedItems,
        total: state.total,
        topping: state.topping
    }
}

const mapDispatchToProps = (dispatch)=>{
    return{
        addShipping: ()=>{dispatch({type: 'ADD_SHIPPING'})},
        substractShipping: ()=>{dispatch({type: 'SUB_SHIPPING'})}
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(Sidebar)

